import type { VendorBadge, VendorXP, VendorXpLedgerEnvelope } from '@repo/shared-types';
import { apiTransport as router } from './transport';
import type { QueryFilters } from './transport';
import { getContext } from './core';

export const vendorGamificationApi = {
  xp: {
    list: async (vendorId: string, filters?: QueryFilters) => {
      const context = getContext();
      return router.get<VendorXpLedgerEnvelope>(`/vendors/${vendorId}/gamification/xp`, context, filters);
    },
    award: async (vendorId: string, amount: number, reason: string, source?: string, ticketId?: string) => {
      const context = getContext();
      return router.post<VendorXP>(`/vendors/${vendorId}/gamification/xp`, { amount, reason, source, ticketId }, context);
    },
  },
  getAllXP: async () => {
    const context = getContext();
    return router.get<VendorXP[]>('/vendors/gamification/xp/all', context);
  },
  getAllBadges: async () => {
    const context = getContext();
    return router.get<VendorBadge[]>('/vendors/gamification/badges/all', context);
  },
  badges: {
    list: async (vendorId: string) => {
      const context = getContext();
      return router.get<VendorBadge[]>(`/vendors/${vendorId}/gamification/badges`, context);
    },
    award: async (vendorId: string, badgeId: string, name: string, description: string, icon?: string, category?: string) => {
      const context = getContext();
      return router.post<VendorBadge>(`/vendors/${vendorId}/gamification/badges`, { badgeId, name, description, icon, category }, context);
    },
  },
};
